import React from "react";
import PropTypes from "prop-types";
import packageJson from "./../../../package.json";

export default class Footer extends React.Component {
  render() {
    if (process.env.REACT_APP_LOGO_URL) {
      return (
        <footer className="footer fixed">
          <span className="float-right">Registro de contrato de financiamento de veículos</span>
        </footer>
      );
    } else {
      return (
        <div class="fixed-bottom">
          <footer className="footer fixed">
            <span className="float-right">
              {this.props.footer && this.props.footer !== null ? (
                <strong>{this.props.footer}</strong>
              ) : (
                <span>
                  <strong>E-REGISTRO</strong> - Registro de contrato de financiamento de veículos - v{packageJson.version}
                </span>
              )}
            </span>

            <span>&copy; {this.props.copyright && this.props.copyright !== null ? this.props.copyright : "2018 Alias"}</span>
          </footer>
        </div>
      );
    }
  }
}

Footer.propTypes = {
  footer: PropTypes.string.isRequired,
  copyright: PropTypes.string.isRequired,
};
